function DP_FLASH(messages) {
  messages.forEach( (message) => {
      let flashArea = document.getElementById("flash-area");
      flashArea.innerHTML += '<div class="alert alert-' + message.type + '">'
        + '<button type="button" class="close" data-dismiss="alert">&times;</button>'
        + message.message
        + '</div>';
  });

}

export default DP_FLASH;